<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      navigationPath="HelpDeskTechnicianRequestView"
      navigationField="displayID"
      :selectionEnabled="false"
      :onLoaded="mapResults"
      name="HelpDeskTechnicianRequests"
    ></dx-grid>

    <CreateTicketByTech
      v-model="newTicketTech"
      @newTicketSended="reloadGrid()"
    />
    <v-dialog
      :style="{ padding: '0 !important' }"
      v-model="dashboardDialog"
      max-width="1000"
    >
      <DashboardSummary
        v-if="loadDashboard"
        :isDialog="true"
        @closeDashboardDialog="dashboardDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import CreateTicketByTech from "./CreateTicketByTech.vue";
import PortalUserAutocomplete from "./PortalUserAutocomplete.vue";
import DashboardSummary from "./DashboardSummary.vue";
export default {
  components: {
    CreateTicketByTech,
    PortalUserAutocomplete,
    DashboardSummary,
  },
  data: () => ({
    filterOverdue: false,
    title: "Support Tickets",
    url: "",
    actions: [],
    processing: false,

    activeTechnicians: [],
    filterForTechnician: "",
    selectedTechnicians: [],

    statuses: ["Open", "On Hold", "Closed"],
    filterForStatus: "",
    selectedStatuses: [],

    newTicketTech: false,

    dashboardDialog: false,
    loadDashboard: false,
    rules: {
      required: (value) => !!value || "Required.",
    },

    columns: [
      {
        field: "priorityName",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          return "mdi-box-shadow";
        },
        iconColor: (value) => {
          switch (value) {
            case "1 High":
            case "3 Option 8":
              return "#e74c3c";
            case "2 Normal":
              return "#f39c12";
            case "4 Low":
              return "#7f8c8d";
            default:
              return "#bdc3c7";
          }
        },
      },
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          switch (value) {
            case "Closed":
              return "mdi-check-circle";
            case "Open":
            case "Reopened":
              return "mdi-clock";
            case "On Hold":
              return "mdi-clock";
            case "Canceled":
              return "mdi-cancel";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "Closed":
              return "#2ecc71";
            case "Open":
            case "Reopened":
              return "#f1c40f";
            case "On Hold":
              return "#3498db";
            case "Canceled":
              return "#e74c3c";
            default:
              return "#bdc3c7";
          }
        },
      },
      // {
      //     label: "Status",
      //     field: "statusName",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Ticket Number",
        field: "displayID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        link: "HelpDeskTechnicianRequestView",
        template: "link-cell-template",
        cssClass: "width-100",
      },
      {
        label: "Name",
        field: "requesterName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Subject",
        field: "subject",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Created At",
        field: "createdAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Technician",
        field: "technicianName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Duration Time",
        field: "durationTime",
        visible: true,
        type: "string",
        allowFiltering: false,
        allowHeaderFiltering: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Due By",
        field: "dueByAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "ETA",
        field: "dueByTimeValue",
        visible: true,
        filterValues: [],
        filterValue: null,
        allowFiltering: false,
        allowHeaderFiltering: false,
        selectedFilterOperation: null,
        template: "text-color-cell-template",
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "requestSiteName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "requesterDepartmentName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Completed Time",
        field: "completedTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },

      {
        label: "Last Sync Time",
        field: "lastSyncTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },

      {
        label: "Requester Email",
        field: "requesterEmailID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "User",
        field: "username",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Technician Email",
      //     field: "technicianEmailID",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
    ],
  }),
  methods: {
    async beforeSetupGrid() {
      await this.getTechniciansOnTickets();
      this.columns.find((c) => c.field == "dueByTimeValue").getTextColor = (
        value
      ) => {
        if (!value) return;
        if (value.startsWith("In")) {
          return "blue";
        } else {
          return "red";
        }
      };

      //   if (this.$route.query.statuses) {
      //     localStorage.setItem("status-filter-tech", this.$route.query.statuses);
      //   }
      //   if (this.$route.query.technician) {
      //     localStorage.setItem(
      //       "technicians-filter-tech",
      //       this.$route.query.technician
      //     );
      //   }
      //   if (this.$route.query.filterOverdue) {
      //     localStorage.setItem(
      //       "filter-overdue-tech",
      //       this.$route.query.filterOverdue
      //     );
      //   }
      this.setFilter();

      this.actions.push({
        text: "Dashboard",
        align: "left",
        action: this.openDashboardDialog,
      });

      this.actions.push({
        text: "Filter Overdue",
        type: "switch",
        align: "left",
        value: this.filterOverdue,
        action: this.onFilterOverdueChanged,
      });

      this.actions.push({
        text: "Select Status",
        values: this.statuses,
        type: "select",
        multiple: true,
        value: this.selectedStatuses,
        onSelected: this.onStatusSelected,
      });

      this.actions.push({
        text: "Select Technicians",
        values: this.activeTechnicians,
        type: "select",
        width: "300px",
        multiple: true,
        value: this.selectedTechnicians,
        onSelected: this.onTechSelected,
      });

      this.actions.push({
        text: "Create Ticket For user",
        action: this.openNewTicketTech,
      });

      // this.actions.push({
      //   text: "Sync open Tickets",
      //   action: this.syncOpenTickets,
      // });
      if (this.$route.query.openNewTicket) {
        this.openNewTicketTech();
      }
    },

    // isTechnician() {
    //   const roles = this.$store.getters["authentication/getRoles"];
    //   const isTech = roles.includes("Technician");
    //   return isTech;
    // },
    openNewTicketTech() {
      this.newTicketTech = true;
    },

    reloadGrid() {
      this.$refs.grid.reloadGrid();
    },
    async getTechniciansOnTickets() {
      const response = await this.$http.get(
        `api/manageengine/getTechniciansOnTickets?includeTechsWithClosedOnly=false`
      );
      this.activeTechnicians = [
        //  { text: "All Tickets", value: "" },
        { text: "Unassigned", value: "Unassigned" },
        ...response.map((tech) => ({ text: tech, value: tech })),
      ];
    },

    onTechSelected(value) {
      localStorage.setItem("technicians-filter-tech", JSON.stringify(value));
      this.selectedTechnicians = value;
      this.setFilter();
      this.$refs.grid.reloadDataSource(this.url);
    },

    onStatusSelected(value) {
      localStorage.setItem("status-filter-tech", JSON.stringify(value));
      this.selectedStatuses = value;
      this.setFilter();
      this.$refs.grid.reloadDataSource(this.url);
    },

    mapResults(results) {
      this.loadDashboard = true;
      results.map((t) => {
        t.technicianName =
          t.technicianName == "UserPortal" ? "" : t.technicianName;
        if (t.statusName != "Closed") {
          t.dueByTimeValue = this.getDueBy(t.dueByTimeValue);
        } else {
          t.dueByTimeValue = null;
        }
        if (t.durationTime) {
          t.durationTime = this.formatDuration(t.durationTime);
        }
        return t;
      });
    },

    getDueBy(dueByTimeValue) {
      if (!dueByTimeValue) return null;
      const currentTime = new Date().getTime();

      const distance = dueByTimeValue - currentTime;

      const absDistance = Math.abs(distance);
      const days = Math.floor(absDistance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (absDistance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((absDistance % (1000 * 60)) / 1000);

      const timeStr = `${days ? days + " days" : ""} ${
        hours ? hours + " hours" : ""
      }  ${minutes} minutes`;

      if (distance >= 0) {
        return `In ${timeStr}`;
      } else {
        return `Delay by ${timeStr}`;
      }
    },
    formatDuration(milliseconds) {
      if (!milliseconds || milliseconds === 0) return "";

      const totalSeconds = Math.floor(milliseconds / 1000);
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;

      const parts = [];
      if (days > 0) {
        parts.push(`${days} ${days === 1 ? "day" : "days"}`);
      }
      if (hours > 0) {
        parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
      }
      if (minutes > 0) {
        parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
      }
      if (seconds > 0 && parts.length === 0) {
        parts.push(`${seconds} ${seconds === 1 ? "second" : "seconds"}`);
      }

      return parts.length > 0 ? parts.join(" ") : "0 seconds";
    },
    async syncOpenTickets() {
      try {
        await this.$http.post(`api/manageengine/UpdateOpenTickets`);
        this.reloadGrid();
        this.$notify({
          text: "Open Tickets Syncked",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      }
    },

    setFilter() {
      var savedTechniciansFilter = localStorage.getItem(
        "technicians-filter-tech"
      );
      var savedStatusFilter = localStorage.getItem("status-filter-tech");

      var savedFilterOverdue = localStorage.getItem("filter-overdue-tech");
      if (savedFilterOverdue) {
        this.filterOverdue = savedFilterOverdue == "true" ? true : false;
      }

      if (savedTechniciansFilter) {
        try {
          this.selectedTechnicians = JSON.parse(savedTechniciansFilter);
          if (!Array.isArray(this.selectedTechnicians)) {
            this.selectedTechnicians = savedTechniciansFilter
              ? [savedTechniciansFilter]
              : [];
          }
        } catch (e) {
          this.selectedTechnicians = savedTechniciansFilter
            ? [savedTechniciansFilter]
            : [];
        }
      } else {
        this.selectedTechnicians = [];
      }
      this.filterForTechnician =
        this.selectedTechnicians.length > 0
          ? this.selectedTechnicians.join(", ")
          : "";

      if (savedStatusFilter) {
        try {
          this.selectedStatuses = JSON.parse(savedStatusFilter);
          if (!Array.isArray(this.selectedStatuses)) {
            this.selectedStatuses = savedStatusFilter
              ? [savedStatusFilter]
              : [];
          }
        } catch (e) {
          this.selectedStatuses = savedStatusFilter ? [savedStatusFilter] : [];
        }
      } else {
        this.selectedStatuses = [];
      }

      this.filterForStatus =
        this.selectedStatuses.length > 0
          ? this.selectedStatuses.join(", ")
          : "";

      this.url = `manageengine?statuses=${this.filterForStatus}&technicians=${
        this.filterForTechnician
      }&filterForUserId=false&filterOverdue=${this.filterOverdue}`;

      // Apply dashboard filter if exists
      const dashboardFilter = localStorage.getItem("dashboard-summary-filter");
      if (dashboardFilter) {
        console.log(dashboardFilter);
        // Clear all existing filters first
        // this.columns.forEach((c) => {
        //   c.filterValue = null;
        //   c.filterValues = [];
        //   c.selectedFilterOperation = null;
        // });

        // try {
        //   const filter = JSON.parse(dashboardFilter);
        //   const columnField =
        //     filter.dateType === "createDate" ? "createdAt" : "dueByAt";
        //   const column = this.columns.find((c) => c.field === columnField);
        //   if (column) {
        //     const fromDate = new Date(filter.fromDate + "T00:00:00");
        //     const toDate = new Date(filter.toDate + "T00:00:00");
        //     toDate.setDate(toDate.getDate() + 1);
        //     column.filterValue = [fromDate, toDate];
        //     column.selectedFilterOperation = "between";
        //   }
        // } catch (e) {
        // } finally {
        //   // localStorage.removeItem("dashboard-summary-filter-requests-show");
        // }
      }
    },

    onFilterOverdueChanged(value) {
      localStorage.setItem("filter-overdue-tech", value);
      this.filterOverdue = value;
      this.setFilter();
      this.$refs.grid.reloadDataSource(this.url);
    },
    openDashboardDialog() {
      this.loadDashboard = true;
      this.dashboardDialog = true;
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
